// src/pages/Gallery.jsx
import React, { useMemo, useState } from "react";
import Section from "../components/Section";
import data from "../data/gallery.json"; // generated at prestart/prebuild

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "radio", label: "Radio Installs" },
  { key: "speakers", label: "Speaker Installs" },
  { key: "amps", label: "Amp Installs" },
  { key: "subs", label: "Sub Installs" },
  { key: "big-projects", label: "Big Projects" },
];

function Tabs({ value, onChange }) {
  return (
    <div className="row" role="tablist" aria-label="Install type filter" style={{ flexWrap: "wrap" }}>
      {CATEGORIES.map((c) => {
        const isActive = c.key === value;
        return (
          <button
            key={c.key}
            role="tab"
            aria-selected={isActive}
            className={isActive ? "btn btn-primary" : "btn btn-outline"}
            onClick={() => onChange(c.key)}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}

function ImageGrid({ images, categoryLabel }) {
  if (!images.length) {
    return <p className="muted small" style={{ marginTop: 16 }}>No images in {categoryLabel} yet.</p>;
  }
  return (
    <div className="grid grid-3-md" style={{ marginTop: 16 }}>
      {images.map((src, i) => (
        <figure key={src + i} className="card" style={{ padding: 8 }}>
          <img
            src={src}
            alt={`${categoryLabel} ${i + 1}`}
            loading="lazy"
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </figure>
      ))}
    </div>
  );
}

export default function Gallery() {
  const [filter, setFilter] = useState("all");

  const allImages = useMemo(() => {
    const merged = Object.values(data).flat();
    // De-dupe (safety)
    return Array.from(new Set(merged));
  }, []);

  const images = useMemo(() => {
    if (filter === "all") return allImages;
    return data[filter] ?? [];
  }, [filter, allImages]);

  const activeLabel = useMemo(() => {
    const found = CATEGORIES.find((c) => c.key === filter);
    return found?.label ?? "Gallery";
  }, [filter]);

  return (
    <Section title="Gallery" subtitle="Browse installs by type.">
      <Tabs value={filter} onChange={setFilter} />
      <ImageGrid images={images} categoryLabel={activeLabel} />
      {filter === "all" && (
        <div style={{ marginTop: 32 }}>
          {CATEGORIES.filter((c) => c.key !== "all").map((cat) => (
            <div key={cat.key} style={{ marginTop: 28 }}>
              <h3 className="h3" style={{ marginBottom: 8 }}>{cat.label}</h3>
              <ImageGrid images={data[cat.key] ?? []} categoryLabel={cat.label} />
            </div>
          ))}
        </div>
      )}
    </Section>
  );
}
